import styled from 'styled-components';
import { useEffect, useState } from 'react';
import {
	Card,
	Divider,
	Pagination,
	Button,
	Modal,
	Form,
	Input,
	message,
	Select,
} from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import remakeQueryString from '../../methods/utils/remake-query-string';
import {
	getMoneyBookList,
	createMoneyBook,
} from '../../methods/redux/reducers/moneyBook';
import Bulk from './book';
import { getCurrencies } from '../../methods/redux/reducers/currency';

export const TableHeader = styled.th`
	padding: 12px 20px;
	text-align: left;
	font-weight: 800;
	color: #262626;
	border-bottom: 1px solid #f0f0f0;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr;
`;

export const StyledFormItem = styled(Form.Item)`
	.ant-row {
		display: block;
	}
`;

const MoneyBook = () => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [refresh, setRefresh] = useState(0);
	const [form] = Form.useForm();

	const { walletSnapshotReport } = useAppSelector((store) => store.reports);
	const { moneyBookList } = useAppSelector((store) => store.moneyBook);
	const { currencies } = useAppSelector((store) => store.currencies);

	const [isLoadingCreateJob, setIsLoadingCreateJob] = useState(false);

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(walletSnapshotReport.paginator.perPage),
			});
		} else {
			dispatch(getMoneyBookList(queryData));
		}

		dispatch(getCurrencies({}));
	}, [searchParams, dispatch, walletSnapshotReport.paginator.perPage, refresh]);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	const currencySelect = currencies.map((item: any) => ({
		label: item.symbol,
		value: item.symbol,
	}));

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
	};

	const handleSubmit = async (values: any) => {
		try {
			setIsLoadingCreateJob(true);

			const jobData = {
				title: values.title,
				funder: values.funderEmail,
				currency: values.currency,
			};

			await dispatch(createMoneyBook(jobData));
			handleCancel();
			form.resetFields();
			setRefresh(Math.random());
		} catch (error) {
			message.error('Failed to create money book');
		} finally {
			setIsLoadingCreateJob(false);
		}
	};

	return (
		<Card>
			<h1>Bulk Sender Payroll</h1>
			<p>Track and manage your income, expenses, and financial records.</p>

			<Button
				type="primary"
				onClick={showModal}
				style={{ marginTop: '16px', marginBottom: '16px' }}
			>
				Create Payroll
			</Button>

			<Divider />

			<p>
				Total of{' '}
				<strong>{moneyBookList?.BulkSenderMoneyBook?.length} items</strong>{' '}
				found
			</p>

			<Divider />

			{/* <Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={walletSnapshotReport.paginator.itemCount}
				current={walletSnapshotReport.paginator.currentPage}
				pageSize={walletSnapshotReport.paginator.perPage}
				showSizeChanger
				showQuickJumper
			/> */}

			<br />

			<TableHeader>
				<div>Title</div>
				<div>Funder</div>
				<div>Status</div>
			</TableHeader>

			{moneyBookList?.BulkSenderMoneyBook?.length > 0 &&
				moneyBookList?.BulkSenderMoneyBook.map((item: any) => (
					<Bulk key={item._id} item={item} />
				))}

			<br />

			<Divider />
			<Pagination
				onChange={(pageId) => updateQueryString({ pageId })}
				total={walletSnapshotReport.paginator.itemCount}
				current={walletSnapshotReport.paginator.currentPage}
				pageSize={walletSnapshotReport.paginator.perPage}
				showSizeChanger
				showQuickJumper
			/>

			{/* Modal for Creating a Money Book */}
			<Modal
				title="Create Payroll"
				visible={isModalVisible}
				onCancel={handleCancel}
				footer={null}
			>
				<Form form={form} onFinish={handleSubmit}>
					<StyledFormItem
						name="title"
						label="Job Title"
						rules={[{ required: true, message: 'Please input the job title!' }]}
					>
						<Input placeholder="e.g., Wicrypt Monthly Salary" />
					</StyledFormItem>

					<StyledFormItem
						name="funderEmail"
						label="Funder Email"
						rules={[
							{ required: true, message: 'Please input the funder email!' },
						]}
						initialValue="salary_service@xend.finance"
					>
						<Input placeholder="Enter funder email" />
					</StyledFormItem>

					<StyledFormItem
						name="currency"
						label="Currency to Xend"
						rules={[{ required: true, message: 'Please select a currency!' }]}
					>
						<Select placeholder="Select a currency" options={currencySelect} />
					</StyledFormItem>

					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							loading={isLoadingCreateJob}
						>
							{isLoadingCreateJob ? 'Creating...' : 'Create Payroll'}
						</Button>
						<Button onClick={handleCancel} style={{ marginLeft: '8px' }}>
							Cancel
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</Card>
	);
};

export default MoneyBook;
